/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  ListRequestedContactsQueryResponse,
  ListRequestedContactsPathParams,
  ListRequestedContactsQueryParams,
} from '../types/ListRequestedContacts'

function getListRequestedContactsUrl({
  job_id,
}: {
  job_id: ListRequestedContactsPathParams['job_id']
}) {
  const res = {
    method: 'GET',
    url: `/api/v1/contact_request/${job_id}/requested-contacts/` as const,
  }
  return res
}

/**
 * @summary List the contacts found for a contact request job
 * {@link /api/v1/contact_request/:job_id/requested-contacts/}
 */
export async function listRequestedContacts(
  { job_id }: { job_id: ListRequestedContactsPathParams['job_id'] },
  params?: ListRequestedContactsQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    ListRequestedContactsQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: 'GET',
    url: getListRequestedContactsUrl({ job_id }).url.toString(),
    params,
    ...requestConfig,
  })
  return res.data
}
